import {
  OfferLogsType,
  ProductAvailableType,
  UsageLogsType,
} from 'api/productApi'
import {USAGE_PERIOD_UNIT} from 'pages/ProductsPages/constant'

export type MonthRange = {
  monthNumber: number
  startDate: number
  endDate: number
}

export interface BulkDataTable {
  usageDateTime: number
  method: string
  usageId: string
  reason: string
}

export interface MonthlyDataTable extends BulkDataTable {
  details: string
  manualPayment: string
  rechargeCurrentMonth: string
  rechargeCarryover: string
  use: number | string
}

export interface MergeLogType extends OfferLogsType, UsageLogsType {}

const getMonthsInRange = (
  startTimestamp: number,
  endTimestamp: number,
): MonthRange[] => {
  const months: MonthRange[] = []
  let currentDate = new Date(startTimestamp)
  const endDate =
    new Date(endTimestamp) < new Date() ? new Date(endTimestamp) : new Date()

  // Vòng lặp để duyệt qua từng tháng
  while (currentDate <= endDate) {
    const year = currentDate.getFullYear()
    const month = currentDate.getMonth()

    // Lấy ngày đầu tiên của tháng
    const startDate = new Date(year, month, 1).getTime()

    // Lấy ngày cuối cùng của tháng
    const nextMonth = new Date(year, month + 1, 1)
    const endDate = new Date(nextMonth.getTime() - 1).getTime()

    const monthNumber = month + 1

    // Thêm vào danh sách
    months.push({
      monthNumber,
      startDate,
      endDate,
    })

    // Chuyển sang tháng tiếp theo
    currentDate = new Date(year, month + 1, 1)
  }

  return months
}

export const combineAndIncludeAllItems = (
  listA: OfferLogsType[],
  listB: UsageLogsType[],
): MergeLogType[] => {
  // Chuyển đổi cả hai danh sách thành Map để tra cứu nhanh chóng
  const mapA = new Map<string, OfferLogsType>()
  listA.forEach((item) => mapA.set(item.licenseItemId, item))

  const mapB = new Map<string, UsageLogsType>()
  listB.forEach((item) => mapB.set(item.licenseItemId, item))

  // Tạo một Set chứa tất cả các licenseId duy nhất từ cả hai danh sách
  const allLicenseIds = new Set<string>()
  listA.forEach((item) => allLicenseIds.add(item.licenseItemId))
  listB.forEach((item) => allLicenseIds.add(item.licenseItemId))

  const combinedList: any[] = []

  // Lặp qua tất cả các licenseId duy nhất
  allLicenseIds.forEach((id) => {
    const itemA = mapA.get(id)
    const itemB = mapB.get(id)

    // Tạo một đối tượng mới bằng cách gộp các thuộc tính (nếu có)
    const combinedItem: any = {
      licenseItemId: id,
      ...(itemA && itemA),
      ...(itemB && itemB),
    }

    combinedList.push(combinedItem)
  })

  return combinedList
}

export default getMonthsInRange
